module.exports = __webpack_public_path__ + "static/qby-2843ca90eec289b82dee157354c1120b.png";